import { Component, OnInit } from '@angular/core';
import { StoreFsrhDetailsService } from '../services/store-fsrh-details.service';


@Component({
  selector: 'app-taking-hormonal-contraception',
  templateUrl: './taking-hormonal-contraception.component.html',
  styleUrls: ['./taking-hormonal-contraception.component.scss']
})
export class TakingHormonalContraceptionComponent implements OnInit {
  takingHormonalMethods;
  takingCOC;
  takingPOP;
  takingImplant;
  takingDepo;
  takingPatchorRing;
  takingIntrauterine;
  wasPeriodNormal=false;
  constructor(private formResult: StoreFsrhDetailsService) {
    this.takingHormonalMethods = formResult.takingHormonalMethods;
    this.takingCOC = formResult.takingCOC;
    this.takingPOP = formResult.takingPOP;
    this.takingImplant = formResult.takingImplant;
    this.takingDepo = formResult.takingDepo;
    this.takingPatchorRing = formResult.takingPatchorRing;
    this.takingIntrauterine = formResult.takingIntrauterine;
    this.wasPeriodNormal = formResult.wasPeriodNormal;
  }


    ngOnInit() {
  }

}
